import axios, { AxiosInstance } from 'axios';
import { StorageStatsByDateResponse } from './model/storageStatsByDateResponse';
import { StorageStatsResponse } from './model/storageStatsResponse';

const API_URL = process.env.REACT_APP_API_URL;
const STORAGE_STATS_URL = `${API_URL}/storage-stats`;
const STORAGE_STATS_BY_DATE_URL = `${STORAGE_STATS_URL}/by-date`;

export async function getStorageStats(
  axiosInstance: AxiosInstance = axios.create(),
): Promise<StorageStatsResponse[]> {
  const response = await axiosInstance.get(STORAGE_STATS_URL);
  return response.data;
}

export async function getStorageStatsByDate(
  axiosInstance: AxiosInstance = axios.create(),
  startDate: string,
  endDate: string,
  project?: string,
): Promise<StorageStatsByDateResponse[]> {
  const response = await axiosInstance.get(STORAGE_STATS_BY_DATE_URL, {
    params: { startDate, endDate, project },
  });
  return response.data;
}
